module.exports = __webpack_public_path__ + "static/GoldPartnerSpesen-660ba64665f0d5ec67e04b0496351303.png";